<!-- 列表组件 -->
<template>
    <div class="c-list">
        <List size="large">
            <a href="javascript: void(0)" v-for="(item,index) in listData" :key="index" @click="openDetails(item)">
                <ListItem class="list-item">
                    <i class="list-item-icon"></i>
                    <span class="toggle-title toggle-title-close">{{ item.title }}</span>
                    <i class="btn-toggle btn-toggle-close" @click.stop="toggleTitle($event, item)"></i>
                </ListItem>
                <div class="list-label-panel">
                    <span class="label-item" v-if="item.zqlx">{{ item.zqlx }}</span>
                    <span class="label-item" v-if="item.xscj">{{ item.xscj }}</span>
                    <span class="label-item" v-if="item.zqly">{{ item.zqly }}</span>
                </div>
            </a>
        </List>
    </div>
</template>

<script>
    export default {
        name: 'CList',
        props: {
            listData: {
                type: Array,
                default() {
                    return []
                }
            },
            activeXscj: {
              type: String,
              default() {
                  return ''
              }
            }
        },
        data() {
            return {

            }
        },
        computed: {},
        mounted() {

        },
        methods: {
            // 打开详情页
            openDetails(item) {
                // 获取router中的href
                const { href } = this.$router.resolve({
                    name: 'Details',
                    query: {
                        id: item.id,
                        xscj: this.activeXscj
                    },
                    params: item
                });
                window.open(href, '_blank')
                // this.$router.push({ name: 'Details', query: { id: item.id }, params: item});
            },

            // 展开标题面板
            toggleTitle(ev, item) {
                if (ev.target.className == 'btn-toggle btn-toggle-open') {
                    ev.target.className = 'btn-toggle btn-toggle-close';
                    ev.target.previousSibling.className = 'toggle-title toggle-title-close'
                } else {
                    ev.target.className = 'btn-toggle btn-toggle-open';
                    ev.target.previousSibling.className = 'toggle-title toggle-title-open'
                }
            }
        }
    }
</script>

<style scoped>
    .c-list {}

    .list-item {
        padding: 5px 20px;
        margin: 16px 0 5px;
        border: 1px solid #e4e8e9;
        border-radius: 3px;
        font-size: 16px;
        /* font-weight: bold; */
        color: #23353d;
        cursor: pointer;
    }

    .list-item:hover {
        color: #2d4060;
        box-shadow: 0 0 10px 2px #f0f3fb;
    }

    .list-item:hover .list-item-icon {
        background-color: #2d4060;
    }

    .ivu-list-split .ivu-list-item:last-child {
        border-bottom: 1px solid #e4e8e9;
    }

    .list-item-icon {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #b0c1c9;
    }

    .btn-toggle {
        width: 40px;
        height: 40px;
        background: url(../../assets/dropdown-gray.png) no-repeat center center;
        transition: all 0.6s;
    }

    .btn-toggle-open {
        transform: rotate(180deg);
    }

    .btn-toggle-close {
        transform: rotate(0deg);
    }

    .toggle-title {
        margin: 0 14px;
        width: 100%;
        font-size: 15px;
    }

    .toggle-title-close {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .label-item {
        padding: 2px 10px;
        margin: 0 8px;
        color: #585f62;
        background-color: #f7f8fc;
    }
</style>